<template>
   <nav
      :class="[
         'top-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg',
         { 'nav-scrolled': isScrolled },
      ]"
   >
      <div
         class="container px-4 mx-auto flex flex-wrap items-center justify-between"
      >
         <div
            class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start"
         >
            <router-link
               class="text-white text-sm font-bold leading-relaxed inline-flex items-center mr-4 py-2 whitespace-nowrap"
               to="/"
            >
               <img
                  :src="amiLogo"
                  alt="Advanced Measurements Inc."
                  class="nav-logo mr-2 flex-shrink-0"
               />
               <span class="tracking-wide">AMI</span>
               <span class="font-normal text-blueGray-200 ml-2 hidden sm:inline"
                  >Advanced Measurements Inc.</span
               >
            </router-link>
            <button
               class="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
               type="button"
               v-on:click="setNavbarOpen"
            >
               <i class="text-white fas fa-bars"></i>
            </button>
         </div>
         <div
            class="lg:flex flex-grow items-center"
            :class="[
               navbarOpen ? 'block rounded shadow-lg bg-gray-800' : 'hidden',
            ]"
         >
            <ul class="flex flex-col lg:flex-row list-none lg:ml-auto items-center">
               <li class="flex items-center">
                  <router-link
                     class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold"
                     to="/wavedata"
                  >
                     <i
                        class="fas fa-cloud text-lg leading-lg mr-2 text-lightBlue-300"
                     ></i>
                     WaveData Cloud
                  </router-link>
               </li>
               <li class="flex items-center">
                  <waveedge-dropdown />
               </li>
               <li class="flex items-center">
                  <dvcommand-dropdown />
               </li>
               <li class="flex items-center">
                  <router-link
                     class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold"
                     to="/fracsupport"
                  >
                     <i
                        class="fas fa-phone text-lg leading-lg mr-2 text-emerald-300"
                     ></i>
                     Frac Support
                  </router-link>
               </li>
               <li class="flex items-center">
                  <router-link
                     class="text-white px-3 py-4 lg:py-2 flex items-center text-xs font-bold"
                     to="/about"
                  >
                     About
                  </router-link>
               </li>
               <li class="flex items-center ml-0 lg:ml-2">
                  <button
                     type="button"
                     class="text-xs font-bold uppercase px-4 py-2 rounded bg-blue-600 hover:bg-blue-500 text-white shadow transition-colors duration-200 my-2 lg:my-0"
                     @click="goToContact"
                  >
                     Contact
                  </button>
               </li>
            </ul>
         </div>
      </div>
   </nav>
</template>

<script>
import DVCommandDropdown from "@/components/Dropdowns/DVCommandDropdown.vue";
import WaveEdgeDropdown from "@/components/Dropdowns/WaveEdgeDropdown.vue";
import amiLogo from "@/assets/img/ami-logo.png";

export default {
   components: {
      "dvcommand-dropdown": DVCommandDropdown,
      "waveedge-dropdown": WaveEdgeDropdown,
   },
   data() {
      return {
         amiLogo,
         navbarOpen: false,
         isScrolled: false,
      };
   },
   methods: {
      setNavbarOpen: function () {
         this.navbarOpen = !this.navbarOpen;
      },
      handleScroll() {
         this.isScrolled = window.scrollY > 0;
      },
      // SPA scroll to contact — avoids full reload / favicon flash from href="/#contact"
      goToContact() {
         this.navbarOpen = false;
         const scroll = () => {
            const contactSection = document.getElementById("contact");
            if (contactSection) {
               contactSection.scrollIntoView({ behavior: "smooth" });
            }
         };
         if (this.$route.path === "/") {
            scroll();
            return;
         }
         this.$router.push("/").then(() => {
            this.$nextTick(() => {
               setTimeout(scroll, 50);
            });
         });
      },
   },
   mounted() {
      window.addEventListener("scroll", this.handleScroll);
   },
   beforeUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
   },
};
</script>

<style>
nav {
   transition: background-color 0.3s ease;
   background-color: rgba(51, 51, 51, 0);
}

nav.nav-scrolled {
   background-color: rgba(51, 51, 51, 0.65);
}

/* AMI lockup — tall brand mark, sized for the nav row */
.nav-logo {
   height: 2.75rem;
   width: auto;
   display: block;
   object-fit: contain;
}
</style>
